<template>
  <section>
    <div class="promotion-user-outer">
      <div class="promotion-user-inner">
        <span class="promotion-user-image">
          <img src="../../assets/images/common/img-crm-pc.png" alt="100원" />
        </span>
        <h1 class="promotion-user-hd">감사합니다.</h1>
        <p class="promotion-user-txt">
          <span>해지 신청이 취소되었습니다.</span>
          <span>다음 정기 결제일에 100원 결제됩니다.</span>
        </p>
        <a href="/" class="promotion-user-link">확인</a>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    created() {},
  }
</script>
<style scoped>
  .promotion-user-outer {
    z-index: 10;
    width: 1240px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    min-height: 500px;
  }
  .promotion-user-inner {
    padding: 120px 0;
    text-align: center;
    color: #fff;
  }
  .promotion-user-image {
    display: block;
    width: 184px;
    margin: 0 auto;
  }
  promotion-user-image img {
    display: block;
    max-width: 100%;
  }
  .promotion-user-hd {
    margin-top: 40px;
    margin-bottom: 10px;
    font-size: 36px;
    line-height: 54px;
  }
  .promotion-user-txt {
    font-size: 24px;
    line-height: 36px;
    color: #a5a5a5;
  }
  .promotion-user-txt span {
    display: block;
  }
  .promotion-user-link {
    display: block;
    width: 480px;
    padding: 16px 0;
    margin: 40px auto 0;
    font-size: 18px;
    line-height: 28px;
    color: #fff;
    background-color: #00bbec;
    border-radius: 30px;
  }
</style>
